import React from 'react';

/**
 * 영업자 앱 — 로그아웃 재확인 모달 (앱 최대 너비 768px 기준, 수기결제 확인 모달과 동일 톤)
 */
function AppLogoutConfirmModal({ open, onCancel, onConfirm, loading }) {
    if (!open) return null;
    return (
        <div
            role="presentation"
            style={{
                position: 'fixed',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100%',
                maxWidth: '768px',
                height: '100dvh',
                backgroundColor: 'rgba(0,0,0,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
            }}
            onClick={loading ? undefined : onCancel}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="app-logout-confirm-title"
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '85%',
                    maxWidth: '400px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    padding: '28px 24px 20px',
                    boxShadow: '0 10px 25px rgba(15,23,42,0.2)',
                }}
            >
                <div
                    id="app-logout-confirm-title"
                    style={{
                        fontSize: '18px',
                        fontWeight: 600,
                        marginBottom: '12px',
                        color: '#111827',
                    }}
                >
                    로그아웃 하시겠습니까?
                </div>
                <div
                    style={{
                        fontSize: '15px',
                        color: '#6B7280',
                        marginBottom: '24px',
                        lineHeight: 1.5,
                    }}
                >
                    로그아웃하면 다시 로그인해야 서비스를 이용할 수 있습니다.
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                        type="button"
                        disabled={loading}
                        onClick={onCancel}
                        style={{
                            flex: 1,
                            padding: '10px 20px',
                            borderRadius: '12px',
                            border: '1px solid #FECACA',
                            fontSize: '15px',
                            fontWeight: 600,
                            backgroundColor: '#FEF2F2',
                            color: '#B91C1C',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.7 : 1,
                        }}
                    >
                        취소
                    </button>
                    <button
                        type="button"
                        disabled={loading}
                        onClick={onConfirm}
                        style={{
                            flex: 1,
                            padding: '10px 20px',
                            borderRadius: '12px',
                            border: 'none',
                            fontSize: '15px',
                            fontWeight: 600,
                            backgroundColor: '#DC2626',
                            color: '#FFFFFF',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.85 : 1,
                        }}
                    >
                        {loading ? '처리 중...' : '로그아웃'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AppLogoutConfirmModal;
